import * as React from 'react'

import DialogActions  from '@material-ui/core/DialogActions/DialogActions'
import DialogContent  from '@material-ui/core/DialogContent'
import { withFormik } from 'formik'

import { Communication }                                              from '../../redux'
import { ActionButton, InlineError, LoadingOverlay }                  from '../atoms'
import { FullScreenDialog }                                           from '../molecules'
import { CompanyChunk }                                               from './chunks'
import { genValueMapper, proxyFormikSubmission }                      from './form-utils'
import { companySchema, CreateCompanyFormValues, emptyCreateCompany } from './schemas'
import { FormikSubmissionCallback }                                   from './types'

interface CreateCompanyFormProps extends Communication {
  onSubmit: FormikSubmissionCallback<any>
}

const CompanyCreateForm = withFormik<CreateCompanyFormProps, CreateCompanyFormValues>({
  validationSchema: companySchema,
  mapPropsToValues: genValueMapper(emptyCreateCompany),
  handleSubmit:     proxyFormikSubmission,
})(
  props => {
    const {
      fetching,
      error,
      ...rest
    } = props

    return (
      <LoadingOverlay show={fetching}>
        <form onSubmit={props.handleSubmit}>
          <DialogContent>
            <CompanyChunk
              mode={'create'}
              {...rest}
            />
          </DialogContent>
          {error && (
            <DialogContent>
              <InlineError i18nErrorId={error} />
            </DialogContent>
          )}
          <DialogActions>
            <ActionButton
              type={'submit'}
              actionType={'submit'}
              variant={'raised'}
              color={'secondary'}
            />
          </DialogActions>
        </form>
      </LoadingOverlay>
    )
  },
)

const CreateCompanyFormDialog = ({
  isOpen,
  close,
  ...rest
}: any) => (
  <FullScreenDialog
    close={close}
    isOpen={isOpen}
    title={'createCompany'}
  >
    <CompanyCreateForm {...rest} />
  </FullScreenDialog>
)

export default CreateCompanyFormDialog



// WEBPACK FOOTER //
// ./src/components/forms/CompanyCreateForm.tsx